import Pill from "../../../../pill/Pill";

const CancelledPill = () => <Pill kind="primary" data-testid="cancelled-indicator" caption={"Cancelled"} />;

export default CancelledPill;
